import { showToast } from './toasts';

export const showErrorToast = (message: string) => showToast('error', message);
